import React from "react"
import { FormattedDate } from "react-intl"
import { Link } from "react-router-dom"
import { InventorySearchItem } from "../../state/inventory/data/model/types"
import { ORDER_LINES, ORDERS } from "../../state/order/Constants"
import { CONTACTS } from "../contacts"
import { STOCK_DOCUMENT_LINES, STOCK_DOCUMENTS } from "./constants"

export const getRowsData = (item: InventorySearchItem) => {
    const isStockDocument = () => item.typeOfObject === STOCK_DOCUMENT_LINES

    const getDocumentUrl = () => {
        if (item.typeOfObject === ORDER_LINES) {
            return `/${ORDERS}/${item.orderId}/edit`
        }
        return `/${STOCK_DOCUMENTS}/${item.stockDocumentId}/edit`
    }

    const contactUrl = `/${CONTACTS}/${item.contactId}/details`

    return [
        <Link to={getDocumentUrl()} key={`${item.id}-documentIdentifier`}>
            {item.stockDocumentIdentifier ? item.stockDocumentIdentifier : item.orderIdentifier}
        </Link>,
        <FormattedDate
            key={`${item.id ? item.id : item.orderId}-createdAt`}
            year="numeric"
            month="long"
            day="numeric"
            value={new Date(item.createdAt)}
        />,
        <Link to={contactUrl} key={`${item.contactId}-contactIdentifier`}>
            {item.contact ? item.contact.name : item.contactId}
        </Link>,
        <span key={`${item.id}-quantity`}>
            {isStockDocument() 
                ? Number(item.calculatedReserved) > 0 
                    ? Number(item.calculatedReserved) 
                    : Number(item.calculatedInTransit)
                : Number(item.calculatedReserved) || 0
            }
        </span>,
        
    ]
}


// WEBPACK FOOTER //
// ./src/utils/inventory/productQuantitiesListingHelper.tsx